module.exports = __webpack_public_path__ + "img/platforminfo_1.0c326705.png";